import { Button, ButtonGroup, Modal } from "@datapay-by-datacom/design-system";
import { Heading } from "react-aria-components";
import styles from "./WorkPatternImportLeaveConfirmModal.module.css";

interface WorkPatternImportReplaceFileConfirmModalProps {
  isOpen: boolean;
  fileName: string;
  patternCount: number;
  onKeepCurrent: () => void;
  onReplace: () => void;
}

/** Confirms replacing a parsed batch, including edits and validation state. */
export function WorkPatternImportReplaceFileConfirmModal({
  isOpen,
  fileName,
  patternCount,
  onKeepCurrent,
  onReplace,
}: WorkPatternImportReplaceFileConfirmModalProps) {
  return (
    <Modal isOpen={isOpen}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <Heading slot="title">Replace uploaded file?</Heading>
        </div>

        <p className={styles.message}>
          {fileName} will replace {patternCount} parsed pattern
          {patternCount === 1 ? "" : "s"}, including edits, warnings, and
          validation results.
        </p>

        <div className={styles.actions}>
          <ButtonGroup>
            <Button variant="primary" onPress={onKeepCurrent}>
              Keep current file
            </Button>
            <Button variant="tertiary" onPress={onReplace}>
              Replace file
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </Modal>
  );
}
